import { CoreState, Core } from 'module/Core';
import { State as RouterState } from './Router';
import { State as MenuState } from './Menu';
import { State as CategoriesState } from './Categories';
import { State as PageListState } from './PageList';
import { State as PostListState } from './PostList';
import { State as PageState } from './Page';
import { State as PostState } from './Post';
import { State as MainState } from './Main';
import * as ReduxStabilizer from 'lib/redux-stabilizer';
import { ValidAction } from 'lib/redux-stabilizer/types';

export type State = MainState &
  CoreState &
  RouterState &
  MenuState &
  CategoriesState &
  PageListState &
  PostListState &
  PageState &
  PostState;

export type Dispatchable = ReduxStabilizer.Dispatchable<State, Core>;
export type Stabilizers = ReduxStabilizer.Stabilizers<State, Core>;
export type Stabilizer = ReduxStabilizer.Stabilizer<State, Core>;

export const dispatchable = (action: ValidAction<State, Core>): Dispatchable => {
  return ReduxStabilizer.dispatchable(action);
};



// WEBPACK FOOTER //
// ./src/module/Redux/index.ts